export * from './PaymentMethodIcon'
